import { FC } from "react";

import Typography from "@mui/material/Typography";

import GlobalError1x from "assets/images/1x/Illustration_Global-Error1x.jpg";
import GlobalError2x from "assets/images/2x/Illustration_Global-Error2x.png";
import { MessageContainerStyled, PageContainer, PlaceHolderExample, ProgressiveImage } from "components";

const NotExist: FC = () => {
  return (
    <PageContainer justifyContent="center">
      <MessageContainerStyled>
        <ProgressiveImage placeholder={GlobalError1x} src={GlobalError2x}>
          {(src) => <PlaceHolderExample cardImage={src} />}
        </ProgressiveImage>
        <Typography variant="h2" whiteSpace="pre-line">
          {`Uh-oh!`}
        </Typography>
        <Typography variant="body1" whiteSpace="pre-line">
          {`Something didn't go quite as planned.\nPlease reload the page or sign in again.`}
        </Typography>
      </MessageContainerStyled>
    </PageContainer>
  );
};

export default NotExist;
